<div class="page-wrapper py-4">
  <div
    class="image-wrapper flex justify-center items-center w-full h-auto max-w-[343px] max-h-[208px] md:max-w-[531px] md:max-h-[326px] object-contain mb-6 lg:mb-10 md:6"
  >
    <img class="image" src="../../../../../assets/img/my-okeey-cash/ready-to-apply-desktop.png" />
    <img class="image-mobile" src="../../../../../assets/img/my-okeey-cash/ready-to-apply-mobile.png" />
  </div>
  <div class="title mb-6 lg:mb-8 md:6">
    <h1>{{ 'okeeyCash.readyToApply' | translate }}</h1>
  </div>
  <div class="sub-title mb-12 lg:mb-16 md:12">
    <span
      >{{ 'okeeyCash.clickOnTheButtonBelow' | translate }}
      <a (click)="onQuickGuideClick()">{{ 'okeeyCash.quickGuide' | translate }}</a
      >.</span
    >
  </div>
  <div class="buttons">
    <korviu-button color="tertiary" (click)="onApplyToOkeeyCashClick()">{{
      'okeeyCash.applyToOkeeyCash' | translate
    }}</korviu-button>
    <korviu-button color="ghost" (click)="onBackToDashboardClick()">{{
      'okeeyCash.backToDashboard' | translate
    }}</korviu-button>
  </div>
</div>
